import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { HallOfFameStats } from '../models/hall-of-fame-models';

/** Events of the Hall of Fame region: the all-time records of the prediction game. */
export const hallOfFameEvents = eventGroup({
  source: 'Hall of Fame',
  events: {
    loadHallOfFame: type<void>(),
    loadHallOfFameSuccess: type<{ stats: HallOfFameStats }>(),
    loadHallOfFameFailed: type<{ error: string }>(),
  },
});
